module.exports = __webpack_public_path__ + "assets/img/activity-time-e4dc9a29.png";